import React from 'react'
import { Box as BoxBase, Grid as GridBase, styled } from '@mui/material'
import {
  BarChartOutlined as BarChartOutlinedBase,
  TableChartOutlined as TableChartOutlinedBase
} from '@mui/icons-material'

export const Root = styled('div')`
  width: 100%;
`

export const GridContainer = styled(({ leftItem, rightItem, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ leftItem, rightItem, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const ViewButton = styled(({ disabled, selected, hidden, ...props }) => <button {...props} />)`
  background-color: ${props => props.theme.palette.brand.white};
  border: ${props => {
    if (props.disabled) {
      return props.theme.palette.brand.gray1
    }

    return props.selected
      ? `3px solid ${props.theme.palette.brand.primary}`
      : `1px solid ${props.theme.palette.custom.gray}`
  }};
  display: ${props => (props.hidden ? 'none' : 'inline-flex')};
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  height: 39px;
  padding: 10px;
  pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
  user-select: none;
  width: auto;

  &,
  &:active,
  &:focus,
  &:within-focus: {
    outline: 0;
  }

  &:first-of-type {
    margin-left: 16px;
  }

  &:last-of-type {
    margin-left: 16px;
  }

  &:active {
    transform: scale(0.99);
  }

  &:hover {
    border: 2px solid ${props => props.theme.palette.blue[35]};
  }

  & .MuiSvgIcon-root {
    fill: ${props => {
      if (props.disabled) {
        return props.theme.palette.brand.gray1
      }

      return props.selected ? props.theme.palette.brand.primary : props.theme.palette.blue[75]
    }};
    user-select: none;
  }

  &:hover .MuiSvgIcon-root {
    fill: ${props => (props.disabled ? props.theme.palette.brand.gray1 : props.theme.palette.blue[35])};
  }

  ${props => props.theme.breakpoints.down('xs')} {
    &:first-of-type {
      margin-bottom: 2px;
    }

    &:last-of-type {
      margin-top: 2px;
    }
  }
`

export const ChartIcon = styled(BarChartOutlinedBase)`
  &.MuiSvgIcon-root {
    font-size: 19px;
  }
`

export const TableIcon = styled(TableChartOutlinedBase)`
  &.MuiSvgIcon-root {
    font-size: 19px;
  }
`

export const NoData = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.gray3};
  border: 0.5px solid ${props => props.theme.palette.brand.gray1};
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 27px;
  min-height: 325px;
  padding: 48px;
`

export const NoDataImage = styled('img')`
  max-width: 220px;
  width: 100%;
`

export const NoDataTitle = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  font-weight: bold;
  margin: 48px auto 0px;
  text-align: center;
`

export const NoDataText = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  max-width: 480px;
  margin: 16px auto;
  text-align: center;
`
export const Box = styled(BoxBase)``
